import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography } from '@mui/material';
import { orderContext } from '../OrderContext';
import { CircleLoader, NumberFormat, DetailsPageHeader } from 'components';
import ShipmentList from './ShipmentList';
import { Check as CheckIcon } from '@mui/icons-material';

let OrderLines = () => {
    let service = useContext(orderContext);

    return (
        <DetailsPageHeader sectionName='Order lines'>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <Table size='small'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Line #</TableCell>
                            <TableCell>Sku</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell align="right">Unit price</TableCell>
                            <TableCell align="center">Qty ordered</TableCell>
                            <TableCell align="center">Qty shipped</TableCell>
                            <TableCell align="center">Qty cancelled</TableCell>
                            <TableCell align="center">Forced close</TableCell>
                            <TableCell align="right">Shipments</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {service.order.orderLines
                            .map((orderLine, index) =>
                                <TableRow hover key={index}>
                                    <TableCell>{orderLine.dueOrderLineId}</TableCell>
                                    <TableCell>{orderLine.sku}</TableCell>
                                    <TableCell>{orderLine.shortDescription}</TableCell>
                                    <TableCell>{orderLine.status}</TableCell>
                                    <TableCell align="right">
                                        <NumberFormat amount={orderLine.unitPrice} suffix={service.order.currency} decimalScale={5} />
                                    </TableCell>
                                    <TableCell align="center">{orderLine.quantityOrdered}</TableCell>
                                    <TableCell align="center">{orderLine.quantityShipped}</TableCell>
                                    <TableCell align="center">{orderLine.quantityCanceled}</TableCell>
                                    <TableCell align="center">{orderLine.forcedRowClosure === true && <CheckIcon />}</TableCell>
                                    <TableCell align="right">
                                        <ShipmentList sku={orderLine.sku} orderId={service.order.id} />
                                    </TableCell>
                                </TableRow>
                            )}
                    </TableBody>
                    {(!service.order.orderLines || service.order.orderLines.length === 0) &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={6}>
                                    <Typography variant="subtitle2">No order lines found</Typography>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
            }
        </DetailsPageHeader>
    );
}

export default OrderLines;